import { render, staticRenderFns } from "./DynamicFormReadOnly.vue?vue&type=template&id=5efde577&scoped=true&"
import script from "./DynamicFormReadOnly.vue?vue&type=script&lang=js&"
export * from "./DynamicFormReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFormReadOnly.vue?vue&type=style&index=0&id=5efde577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efde577",
  null
  
)

export default component.exports